export default [
  {
    path: '/crm/campanhas',
    name: 'crm-campanhas',
    component: () => import('@/views/crm/CampanhasList.vue'),
    meta: {
      pageTitle: 'CRM - Campanhas',
      action: 'read',
      resource: 'MenuCrmCampanhas',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Campanhas', active: true },
      ],
    },
  },
  {
    path: '/crm/campanhas/:id',
    name: 'crm-campanha-detail',
    component: () => import('@/views/crm/CampanhaDetail.vue'),
    meta: {
      pageTitle: 'CRM - Campanha',
      action: 'read',
      resource: 'MenuCrmCampanhas',
      breadcrumb: [
        { text: 'CRM', active: false },
        { text: 'Campanhas', to: '/crm/campanhas' },
        { text: 'Detalhe', active: true },
      ],
    },
  },
];
